var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Staffs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design-Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Components/TurnItBlue/01.Navigation/01.Default-Copy",
    transform: "translate(-20.000000, -129.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-of-Tele-Screens",
    transform: "translate(0.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.328125,31.375 C7.49128125,31.375 8.4375,32.3212187 8.4375,33.484375 L8.4375,33.484375 L8.4375,37 L0,37 L0,33.484375 C0,32.3212187 0.94621875,31.375 2.109375,31.375 L2.109375,31.375 Z M21.890625,31.375 C23.0537813,31.375 24,32.3212187 24,33.484375 L24,33.484375 L24,37 L15.5625,37 L15.5625,33.484375 C15.5625,32.3212187 16.5087187,31.375 17.671875,31.375 L17.671875,31.375 Z M12.703125,25.75 L12.703125,29.2113906 L14.6222813,30.3189531 L13.9191563,31.5370469 L12,30.4287812 L10.0808437,31.5370469 L9.37771875,30.3189531 L11.296875,29.2113906 L11.296875,25.75 L12.703125,25.75 Z M4.21875,25.75 C5.77205086,25.75 7.03125,27.0091991 7.03125,28.5625 C7.03125,30.1158009 5.77205086,31.375 4.21875,31.375 C2.66544914,31.375 1.40625,30.1158009 1.40625,28.5625 C1.40625,27.0091991 2.66544914,25.75 4.21875,25.75 Z M19.78125,25.75 C21.3345509,25.75 22.59375,27.0091991 22.59375,28.5625 C22.59375,30.1158009 21.3345509,31.375 19.78125,31.375 C18.2279491,31.375 16.96875,30.1158009 16.96875,28.5625 C16.96875,27.0091991 18.2279491,25.75 19.78125,25.75 Z M14.109375,18.625 C15.2725313,18.625 16.21875,19.5712187 16.21875,20.734375 L16.21875,20.734375 L16.21875,24.34375 L7.78125,24.34375 L7.78125,20.734375 C7.78125,19.5712187 8.72746875,18.625 9.890625,18.625 L9.890625,18.625 Z M12,13 C13.5533009,13 14.8125,14.2591991 14.8125,15.8125 C14.8125,17.3658009 13.5533009,18.625 12,18.625 C10.4466991,18.625 9.1875,17.3658009 9.1875,15.8125 C9.1875,14.2591991 10.4466991,13 12,13 Z",
    id: "Staffs"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/StaffIcon.d7cf27aac05d789dae44d5a64a10c66f.svg";
export { ForwardRef as ReactComponent };